import React, { useState, useEffect, useRef } from 'react'
import Formsy from 'formsy-react'
import clsx from 'clsx'
import { TextInput } from 'app/components/FormsyHelperComponent'
import { MAX_GROUP_TITLE_TEXT_LENGTH } from 'commons/groupForm'
import {
  Button,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core'
import { useFormsy } from 'commons/form'
import { FormattedMessage } from 'react-intl'
import CancelButton from 'app/components/buttons/CancelButton'
import ResponsiveDialog from 'app/components/dialog/ResponsiveDialog'
import useMobileStyle from 'app/components/mobileModal/mobileModalStyle'

export default (props) => {
  const [isFormValid, setIsFormValid] = useState(false)
  const {
    state,
    classes,
    hendleUpdateSubgroupName,
    toggleDialogs,
    RENAME_SUB_GROUP_DIALOG,
  } = props

  const mobileClasses = useMobileStyle()

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    reset()
    setIsFormValid(false)
  }, [state[RENAME_SUB_GROUP_DIALOG]])
  /* eslint-enable react-hooks/exhaustive-deps */

  const formRef = useRef(null)
  const { isPristine, onChange, reset } = useFormsy(formRef)

  function disableButton() {
    setIsFormValid(false)
  }

  function enableButton() {
    setIsFormValid(true)
  }

  return (
    <ResponsiveDialog
      fullWidth
      isFullScreen={false}
      open={state[RENAME_SUB_GROUP_DIALOG]}
      className={clsx(
        classes.groupDialog,
        classes.groupDialogStyleOne,
        mobileClasses.lessPaddingMobile,
      )}
    >
      <DialogTitle className={classes.groupDeleteTitle}>
        <FormattedMessage id="group.details.dialogs.editSubgroup" />
      </DialogTitle>

      <DialogContent>
        <Formsy
          onValidSubmit={hendleUpdateSubgroupName}
          onChange={onChange}
          onValid={enableButton}
          onInvalid={disableButton}
          ref={formRef}
          className="flex flex-col justify-center w-full"
          id="renameGroupForm"
        >
          <TextInput
            margin="dense"
            value={state.subGroupName}
            containerClassName="mt-16"
            labelId="group.details.dialogs.subgroupName"
            placeholderId="group.details.dialogs.subgroupName"
            name="name"
            variant="outlined"
            type="text"
            autoFocus
            fullWidth
            maxLength={MAX_GROUP_TITLE_TEXT_LENGTH}
            required
          />
        </Formsy>
      </DialogContent>
      <DialogActions className={classes.renameActionBtns}>
        <CancelButton
          onClick={() => {
            toggleDialogs(RENAME_SUB_GROUP_DIALOG, false)
          }}
          className={mobileClasses.modalBtn}
        />
        <Button
          disabled={!isFormValid || isPristine}
          type="submit"
          color="primary"
          className={clsx(
            classes.actionBtn,
            classes.groupActionBtns,
            mobileClasses.modalBtn,
          )}
          variant="contained"
          form="renameGroupForm"
        >
          <FormattedMessage id="action.save" />
        </Button>
      </DialogActions>
    </ResponsiveDialog>
  )
}
